var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
import _ from 'lodash';
import { UserGuideApiDto } from '../types/user-guide-api-dto.interface';
let UserGuideApiImpl = class UserGuideApiImpl {
    constructor(userGuideApiDto) {
        this.userGuideApiDto = userGuideApiDto;
    }
    getUserGuide() {
        return psHttp({
            url: `${workspaceApiUrlPrefix}/space/exist`,
            method: 'GET',
            transformCode: true,
        }).then(({ data }) => {
            const status = _.get(data, 'data', true);
            return this.userGuideApiDto.formateGuideData(!status);
        });
    }
};
UserGuideApiImpl = __decorate([
    injectable(),
    __param(0, inject(UserGuideApiDto)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserGuideApiDto !== "undefined" && UserGuideApiDto) === "function" ? _a : Object])
], UserGuideApiImpl);
export { UserGuideApiImpl };
